import { defineComponent as _defineComponent } from 'vue'
import { computed, getCurrentInstance } from 'vue';
import { useI18n } from 'vue-i18n-bridge';
import ProofreadingApplyConfirmDialog, {
    ProofreadingApplyConfirmDialogResult,
} from '@/components/ui/dialogs/ProofreadingApplyConfirmDialog.vue';
import { Dialog } from '@/lib/utils/dialog';


export default /*#__PURE__*/_defineComponent({
  __name: 'RevisingEditorSaveActions',
  props: {
    novelId: { type: String, required: true },
    isSaving: { type: Boolean, required: true },
    isApplying: { type: Boolean, required: true },
    hasUnsavedChanges: { type: Boolean, required: true },
    showSaveCompleted: { type: Boolean, required: true },
    applyConfirmHandler: { type: Function, required: true }
  },
  emits: ["save-click"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'save-click'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    novelId: string;
    isSaving: boolean;
    isApplying: boolean;
    hasUnsavedChanges: boolean;
    showSaveCompleted: boolean;
    applyConfirmHandler: () => Promise<void>;
};





const { t } = useI18n();
const instance = getCurrentInstance();

const tempSaveLabel = computed(() => {
    if (props.isSaving) {
        return t('proofreadingReviseManuscriptPage.saving');
    }
    if (props.showSaveCompleted) {
        return t('proofreadingReviseManuscriptPage.tempSaveCompleted');
    }
    return t('proofreadingReviseManuscriptPage.tempSave');
});

const applyLabel = computed(() => (
    props.isApplying
        ? t('proofreadingReviseManuscriptPage.applyingToManuscript')
        : t('proofreadingReviseManuscriptPage.applyToManuscript')
));

function onClickSave() {
    emit('save-click');
}

async function onClickApply() {
    if (props.isApplying || props.isSaving) return;

    const dialog = new Dialog(ProofreadingApplyConfirmDialog);
    const result = (await dialog.show({
        onConfirm: props.applyConfirmHandler,
    })) as ProofreadingApplyConfirmDialogResult | undefined;

    if (!result?.confirmed) return;

    instance?.proxy?.$router.push({
        name: 'proofreadingSelectType',
        params: { novelId: props.novelId },
    });
}

return { __sfc: true,props, emit, t, instance, tempSaveLabel, applyLabel, onClickSave, onClickApply }
}

})